import { css } from 'styled-components';
import { ColorNeutralWhite, ColorOpacityDark3 } from 'autogen/design-tokens/tokens';

const chanelTheme = {
    ButtonStyling: css<{ variant: string; $disabled: boolean }>`
        border-radius: 0;
        font-size: 14px;
        font-weight: normal;

        ${({ variant }) =>
            variant !== 'primaryText' &&
            css`
                background: #000000;
                color: white;

                &:hover,
                &:focus {
                    background: #000000;
                    color: white;
                }

                & svg {
                    stroke: ${ColorNeutralWhite};
                }
            `};

            ${({ $disabled }) =>
                $disabled &&
                css`
                    background: ${ColorOpacityDark3};
                
                    &:hover,
                    &:focus {
                        background: ${ColorOpacityDark3};
                    }
                `}
    `
};

export default chanelTheme;
